import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom'

import { useSelector, useDispatch } from 'react-redux'

/**
 * Managing the layers of the extra map features: creating and removing 
 * them in case of data or visibility changes. 

 * All of the layers are created and then removed in all re-renders, as 
 * side effects. 
 */
export default function ExtraMapLayers(props) {

  const map = useSelector((state) => state.ui.map) ;

  const features = useSelector((state) => state.viewport.extraMapFeatures) ;
  const featuresVisibility = useSelector((state) => state.viewport.extraMapFeaturesVisibility)
  const geoJsons = useSelector((state) => state.viewport.geoJsons) ;
  const mapStyleLoading= useSelector((state) => state.ui.mapStyleLoading) ;
  const firstIdleTime = useSelector((state) => state.ui.firstIdleTime) ;

  // to check if initialization was done
  const isInitializedRef = useRef(false)
  const isInitiallyZoomedRef = useRef(false)  
  
  const EMPTY_GEOJSON_DATA = {
    "type": "Feature", "properties": { "icon": "marker1" },
    "geometry": { "type": "Point", "coordinates": [] }
  }

  useEffect(() => {
    // console.log('USEEFFECT: ExtraMapLayers, features.layers:', features.layers)
    // console.log('USEEFFECT: ExtraMapLayers, map:', map)
    // console.log('MBMap.useEffect: ExtraMapLayers, map:', map)

    if ( (! features.layers) || (mapStyleLoading) ) return

    for (var i = 0; i < features.layers.length; i++) {
      const laydef = features.layers[i]
      // if no source and layer exists yet with this ID: adding them
      if (map && ( typeof (map.getSource(laydef.layerId)) === 'undefined')  ) {
        
        //console.log(map.getStyle().layers )
  
        // console.log('adding layer: ', laydef.type, laydef.layerId )
        
        if (laydef.type=="symbol") {
          map.addSource(laydef.layerId, {
            type: 'geojson', data: EMPTY_GEOJSON_DATA
          });
        }
        else if (laydef.type=='line') {
          map.addSource( laydef.layerId, {
            type: 'geojson',
            lineMetrics: false, // true,
            //tolerance: 0.6, // Douglas-Peucker simplification tolerance 
                            // (higher means simpler geometries and faster performance).
                            // Defaults to 0.375
            buffer: 0, // Optional number between 0 and 512 inclusive. Defaults to 128. 
                      // Size of the tile buffer on each side.  
            // cluster: true, 
            data: EMPTY_GEOJSON_DATA
          });        
        }
        // FIX: forced repaint - not working
        // map.triggerRepaint()
      }
      if (map && ( typeof (map.getLayer(laydef.layerId)) === 'undefined')  ) {
        // layer 
        if (laydef.type=="symbol") {
            // merging layer default config and config provided       
          var textSize = 16
          if (laydef.textSize) textSize = laydef.textSize
          var textOffset = [0, 0]
          if (laydef.textOffset) textOffset = laydef.textOffset
          var textTranslate = [0, 0]
          if (laydef.textTranslate) textTranslate = laydef.textTranslate
          // textTranslate = JSON.stringify(textTranslate)
          var icon = "marker1" ;
          if (laydef.icon) icon = laydef.icon 
          var iconSize = 24 ;
          if (laydef.iconSize) iconSize = laydef.iconSize 
          // using the icons defined in MBprops.Map
          const nlay = 
          {
            "id": laydef.layerId,
            "type": "symbol",
            "source": laydef.layerId,
            "layout": {
              "icon-image": icon,
              "icon-anchor": "bottom",
              "icon-size": iconSize,
              'icon-allow-overlap': true,
              'text-field': ['get', 'label'],
              'text-justify': "center",
              'text-anchor': "center",
              'text-size': textSize,
              'text-offset': textOffset,
              'text-allow-overlap': false,
              'text-font': ['Open Sans Semibold', 'Arial Unicode MS Bold'],
            },
            'paint': {
              //'text-color': '#35B63F', // '#009EFF', //'#202',
              'text-halo-color': '#fff',
              'text-halo-width': 4,
              'text-halo-blur': 2,
              'text-translate': textTranslate,
            },                 
          }
          if (map.getLayer('trajectory-placeholder')) {
            map.addLayer(nlay, 'trajectory-placeholder');
          }
          else {
            map.addLayer(nlay);
          }
          
        }
        else if (laydef.type=='line') {        
          var lineWidth = 2 ;
          if (laydef.lineWidth) lineWidth = laydef.lineWidth 
          
          var lineColor = 'FFFFFF' ;
          if (laydef.lineColor) lineColor = laydef.lineColor
          
          const nlay = {
            id: laydef.layerId,
            type: "line",
            source: laydef.layerId,
            paint: {  
              'line-color': lineColor,
              'line-width': lineWidth,
              'line-opacity': 0.8
            }
          }
          if (typeof (map.getLayer('trajectory-placeholder')) === 'undefined') {
            map.addLayer(nlay)
          }
          else {
            map.addLayer(nlay, 'trajectory-placeholder')
          }
          
        }
      }
      if (! map  ) {
        // console.log('ExtraMapLayers: no map to render to: ', map)
      }      
    }

    return () => {
      // alternative would be: only add a layer once, then change content only 
      if (! features.layers) return
      // cleanup 
      for (var i = 0; i < features.layers.length; i++) {
        const laydef = features.layers[i]
        try {
          if (typeof (map.getLayer(laydef.layerId)) === 'undefined')  
            map.removeLayer(laydef.layerId)
          if ( typeof (map.getSource(laydef.layerId)) === 'undefined')
            map.removeSource(laydef.layerId) 
        }
        catch {
          ;
        }
      } 
    }
  }, [ map ]); // features, , mapStyle, mapStyleLoading

  return null ;
}
